export enum FilterTypes {
  GARM = 'GARM Score',
  Host = 'Host',
  Podcasts = 'Podcasts',
  IAB = 'iab',
  Genres = 'Genres',
  CustomTags = 'Custom Tags',
  Publisher = 'Publisher',
  Languages = 'Languages',
}

export enum ScoreExceptionTypes {
  Genre = 'Genre',
  // Podcast = 'Podcast',
  GarmReasoning = 'GARM Reasoning',
}

export enum RiskLevel {
  No = 'No',
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

interface ExceptionFilter {
  name: string;
  risk: RiskLevel;
}

export interface ScoreFilterType {
  type: ScoreExceptionTypes;
  exceptions: ExceptionFilter[];
}

export enum ExceptionTypes {
  Include = 'Include',
  Exclude = 'Exclude',
}

export interface ExceptionFilterType {
  type: ExceptionTypes;
  exceptions: any[];
}

export interface BrandCustomFilter {
  name: string;
  description: string;
  data: any;
  id: string;
  dashboardIds: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface BrandCustomFilterCreateBody {
  name: string;
  description: string;
  data: any;
}
